import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";


const KeyFeatures = ({features}) => {
    
  return (
    <section className="pb-20 sm:pb-[40px]">
        <div className="mx-auto w-full container px-3 md:py-2 xm:py-2 md:px-3">
          <div className="max-w-[1280px] mx-auto w-full">
            <div className="flex justify-center gap-x-5 sm:gap-0 sm:flex-col mx-auto w-full">
                    <div className="w-[45%] sm:w-full">
                        <Image
                        src={IMAGES?.businessLoans?.keyFeatures}
                        width={500}
                        height={400}
                        alt="Documents"
                        quality={100}
                        />
                    </div>
                    <div className="w-2/4 sm:w-full  my-auto sm:mt-12">
                        <h2 className="text-3xl sm:text-xxl text-black font-bold mb-5">
                            Key Features
                        </h2>
                        <div>
                        {features?.map((items) => {
                            return (
                            <div className="sm:w-full mb-5" key={items?.id}>
                                <div className="flex">
                                <Image
                                    src={items?.image}
                                    width={20}
                                    height={20}
                                    alt={items?.heading}
                                    className="mt-[-12px]"
                                />
                                <h3 className="text-base2 text-black font-bold mb-1 ml-2">
                                    {items?.heading}
                                </h3>
                                </div>
                                <p className="text-base2 text-[#3c3c3c] ml-9">
                                {items?.description}
                                </p>
                            </div>
                            );
                        })}
                        </div>
                    </div>
            </div>
          </div>
        </div>
    </section>         
    
  );
};

export default KeyFeatures;
